// extracted by mini-css-extract-plugin
export var boxItems = "_1s-1";
export var button = "_1s-5";
export var filterGroupBox = "_1s-0";
export var icon = "_1s-2";
export var iconSecondary = "_1s-4";
export var iconWrapper = "_1s-3";